import Badge from "@mui/material/Badge";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import CircularProgress from "@mui/material/CircularProgress";
import { styled } from "@mui/material";

const NumberBadgeContainer = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  gap: "16px",
}));

const NumberStyledBadge = styled(Badge)<{
  color: "error" | "warning" | "secondary" | "default" | "primary" | "success" | "info";
}>(({ color, theme }) => ({
  "& .MuiBadge-badge": {
    fontSize: "0.6rem",
    height: "16px",
    minWidth: "16px",
    backgroundColor: color === "default" ? "#888" : undefined,
    color: color === "default" ? theme.palette.common.white : undefined,
  },
}));

type NumberBadgeProps = {
  isLoading?: boolean;
  tooltip?: string;
  text?: string;
  badgeCount?: number;
  color?: "error" | "warning" | "secondary" | "default" | "primary" | "success" | "info";
};

export default function NumberBadge(props: Readonly<NumberBadgeProps>) {
  const { tooltip, text, badgeCount, color, isLoading } = props;

  return (
    <NumberBadgeContainer>
      <span>{text}</span>
      <Tooltip title={tooltip} placement="bottom">
        <NumberBadgeContainer>
          {isLoading ? (
            <CircularProgress size={16} />
          ) : (
            <NumberStyledBadge
              color={badgeCount ? (color ?? "default") : "default"}
              badgeContent={badgeCount}
              showZero={true}
            />
          )}
        </NumberBadgeContainer>
      </Tooltip>
    </NumberBadgeContainer>
  );
}
